export const unitOfMeasure = [
  { id: 'K', name: 'KG' },
  { id: 'L', name: 'LITER' },
];

export const transportationDbFilters = {
  TRANSPORT_MODE: 'Transport_Mode',
  CATEGORY: 'Category',
  UOM: 'Uom',
};

export const transportModeList = [{
  id: transportationDbFilters.TRANSPORT_MODE,
  name: 'Transport Mode',
},
{
  id: transportationDbFilters.CATEGORY,
  name: 'Category',
},
{
  id: transportationDbFilters.UOM,
  name: 'Uom',
}];
